import { frontendURL } from 'dashboard/helper/URLHelper';
import KanbanBoardPage from 'kanban/pages/KanbanBoardPage.vue';
import KanbanBoardSettingsPage from 'kanban/pages/KanbanBoardSettingsPage.vue';
import KanbanOverviewPage from 'kanban/pages/KanbanOverviewPage.vue';
import KanbanProductsPage from 'kanban/pages/KanbanProductsPage.vue';
import KanbanSettingsPage from 'kanban/pages/KanbanSettingsPage.vue';

const KANBAN_ROUTE_PERMISSIONS = ['administrator', 'agent', 'kanban_manage'];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban/settings'),
    component: KanbanSettingsPage,
    name: 'kanban_settings',
    meta: {
      permissions: ['administrator'],
      accountSetting: 'alex_kanban_enabled',
    },
  },
  {
    path: frontendURL('accounts/:accountId/kanban/overview'),
    component: KanbanOverviewPage,
    name: 'kanban_list',
    meta: {
      permissions: KANBAN_ROUTE_PERMISSIONS,
      // The host gate handles the disabled state before this page fetches data.
    },
  },
  {
    path: frontendURL('accounts/:accountId/kanban/:boardId/settings'),
    component: KanbanBoardSettingsPage,
    name: 'kanban_board_settings',
    meta: {
      permissions: KANBAN_ROUTE_PERMISSIONS,
      accountSetting: 'alex_kanban_enabled',
    },
  },
  {
    path: frontendURL('accounts/:accountId/kanban/:boardId/products'),
    component: KanbanProductsPage,
    name: 'kanban_board_products',
    meta: {
      permissions: KANBAN_ROUTE_PERMISSIONS,
      accountSetting: 'alex_kanban_enabled',
    },
  },
  {
    path: frontendURL('accounts/:accountId/kanban/:boardId?'),
    component: KanbanBoardPage,
    name: 'kanban_board_show',
    meta: {
      permissions: KANBAN_ROUTE_PERMISSIONS,
      accountSetting: 'alex_kanban_enabled',
    },
    children: [
      {
        path: 'create',
        name: 'kanban_task_create',
        component: KanbanBoardPage,
        meta: {
          permissions: KANBAN_ROUTE_PERMISSIONS,
          accountSetting: 'alex_kanban_enabled',
        },
      },
      {
        path: 'task/:taskId',
        name: 'kanban_task_show',
        component: KanbanBoardPage,
        meta: {
          permissions: KANBAN_ROUTE_PERMISSIONS,
          accountSetting: 'alex_kanban_enabled',
        },
      },
    ],
  },
];
